import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class TakeSnapshotStore implements SaveStateHolder {
  version: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly lessonId: number) {
    makeObservable(this);
    this.version = new StringControl('', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    this.version.markTouched();
    if (this.version.invalid)
      return;
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x5lessonSnapshot.take(this.lessonId, this.version.value);
  }
}
